[...document.querySelectorAll('.js-add-address')].map(trigger => trigger.addEventListener('click', () => {
    document.querySelector('.js-add-address-form').style.setProperty('display', 'block');
}));

[...document.querySelectorAll('.js-edit-address')].map(trigger => trigger.addEventListener('click', () => {
    document.querySelector(`.js-edit-address-form[data-address="${trigger.dataset.address}"]`).style.setProperty('display', 'block');
}));

